import React, { useState } from 'react';
import { SectionReveal } from './ui/SectionReveal';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';
const photos = [{
  src: 'https://cdn.magicpatterns.com/uploads/jVmJ4PG31BQAFYdrdywD3c/20260302_-_16_-_Homefort_-_Las_Chafiras-3.jpg',
  alt: 'Salón del piso piloto con sofá y comedor'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/3wxkTyiQgEXno4bgL9pFcs/20260302_-_16_-_Homefort_-_Las_Chafiras-5.jpg',
  alt: 'Salón luminoso del piso piloto'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/nvFVzPF49TuXkjHwGmr1Uy/20260302_-_16_-_Homefort_-_Las_Chafiras-4.jpg',
  alt: 'Cocina equipada del piso piloto'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/pqVZJpCioE5KevCbDZZTkc/20260302_-_16_-_Homefort_-_Las_Chafiras-2.jpg',
  alt: 'Terraza del piso piloto con vistas'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/sVrZ5FnPxdRq8eoEpGeNwg/20260302_-_16_-_Homefort_-_Las_Chafiras-1.jpg',
  alt: 'Terraza del piso piloto con vistas al mar'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/hrvTimf9LDn2gj9pXb9tbe/20260302_-_16_-_Homefort_-_Las_Chafiras-6.jpg',
  alt: 'Salón-cocina abierto del piso piloto'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/8Tut2c5ochZpfx7ZNsNEYP/20260302_-_16_-_Homefort_-_Las_Chafiras-7.jpg',
  alt: 'Dormitorio del piso piloto'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/wz14QXcbt75q4sU1Kzxr1b/20260302_-_16_-_Homefort_-_Las_Chafiras-8.jpg',
  alt: 'Dormitorio principal del piso piloto'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/kYopmPKHaEy7BdAVmRDhFp/20260302_-_16_-_Homefort_-_Las_Chafiras-9.jpg',
  alt: 'Baño con ducha y mármol del piso piloto'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/9t1akLC4qJYZzyokSEywYn/20260302_-_16_-_Homefort_-_Las_Chafiras-10.jpg',
  alt: 'Baño con acabados en mármol del piso piloto'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/nV7W9LqCiBEiUwTTGRSxN4/20260302_-_16_-_Homefort_-_Las_Chafiras-11.jpg',
  alt: 'Despacho del piso piloto con zona de estudio'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/hCmwdC3bo14f9krCbzK4jw/20260302_-_16_-_Homefort_-_Las_Chafiras-12.jpg',
  alt: 'Sala de estar adicional del piso piloto'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/gK3iqNDD5tepAbmtirRMBd/20260302_-_16_-_Homefort_-_Las_Chafiras-13.jpg',
  alt: 'Dormitorio doble del piso piloto'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/uV6QideGeib8ke84NjcxM2/20260302_-_16_-_Homefort_-_Las_Chafiras-14.jpg',
  alt: 'Dormitorio con dos camas del piso piloto'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/7LmbT4ZqeKqp4ubVGdet9c/20260302_-_16_-_Homefort_-_Las_Chafiras-15.jpg',
  alt: 'Baño con ducha del piso piloto'
}];
import { useLanguage } from '../context/LanguageContext';
export function AmenitiesSection() {
  const {
    t
  } = useLanguage();
  const [lightbox, setLightbox] = useState<number | null>(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  const next = () => {
    setDirection(1);
    setCurrentIndex(prev => (prev + 1) % photos.length);
  };
  const prev = () => {
    setDirection(-1);
    setCurrentIndex(prev => (prev - 1 + photos.length) % photos.length);
  };
  return <SectionReveal id="zonas-comunes" className="bg-light px-0" data-id="element-20" data-mp="mnqr43zn11q8">
      <div className="container mx-auto px-6 md:px-12" data-id="element-21" data-mp="mqd8evcbyvln">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-22" data-mp="rmbtoa2d3xhu">
          <span className="text-sm tracking-[0.2em] uppercase text-nature mb-4 block" data-id="element-23" data-mp="cyh2iy40616v">
            {t.nav.pisoPiloto}
          </span>
          <h2 className="text-4xl md:text-5xl font-serif text-navy leading-tight" data-id="element-24" data-mp="hwiiha64tke4">
            {t.amenities.title}
          </h2>
        </div>
      </div>

      {/* Full-width Carousel */}
      <div className="relative w-full h-[70vh] md:h-[85vh] overflow-hidden group bg-navy/5" data-id="element-25" data-mp="1ae4kpyxvf8mx">
        <AnimatePresence mode="popLayout" custom={direction} data-id="element-26" data-mp="3iv7c52uco122">
          <motion.button key={currentIndex} custom={direction} onClick={() => setLightbox(currentIndex)} initial={(d: number) => ({
          opacity: 0,
          x: d > 0 ? 60 : -60
        })} animate={{
          opacity: 1,
          x: 0
        }} exit={(d: number) => ({
          opacity: 0,
          x: d > 0 ? -60 : 60,
          position: 'absolute'
        })} transition={{
          duration: 0.45,
          ease: 'easeInOut'
        }} className="absolute inset-0 w-full h-full cursor-zoom-in" aria-label={`Ampliar ${photos[currentIndex].alt}`} data-id="element-27" data-mp="3iskugadqw564">
            <img src={photos[currentIndex].src} alt={photos[currentIndex].alt} className="w-full h-full object-cover" data-id="element-28" data-mp="o6sdgri6wkqh" />
          </motion.button>
        </AnimatePresence>

        {/* Navigation Arrows */}
        <button onClick={prev} className="absolute left-4 top-1/2 -translate-y-1/2 z-10 w-12 h-12 bg-white/90 hover:bg-white text-navy rounded-full flex items-center justify-center backdrop-blur-sm transition-all shadow-lg" aria-label="Imagen anterior" data-id="element-29" data-mp="rqswlpuv73oq">
          <ChevronLeft className="w-6 h-6" data-id="element-30" data-mp="15luxfykuu2uo" />
        </button>
        <button onClick={next} className="absolute right-4 top-1/2 -translate-y-1/2 z-10 w-12 h-12 bg-white/90 hover:bg-white text-navy rounded-full flex items-center justify-center backdrop-blur-sm transition-all shadow-lg" aria-label="Imagen siguiente" data-id="element-31" data-mp="1amiy7byvxy23">
          <ChevronRight className="w-6 h-6" data-id="element-32" data-mp="1odntk1v8046m" />
        </button>

        {/* Counter */}
        <div className="absolute top-4 right-4 z-10 bg-navy/70 text-white text-sm font-medium px-3 py-1.5 rounded-full backdrop-blur-sm" data-id="element-33" data-mp="1tel9e7srcm4y">
          {currentIndex + 1} / {photos.length}
        </div>

        {/* Dot indicators */}
        <div className="absolute bottom-5 left-1/2 -translate-x-1/2 z-10 flex gap-2" data-id="element-34" data-mp="18p99p9ddp8ui">
          {photos.map((_, idx) => <button key={idx} onClick={() => {
          setDirection(idx > currentIndex ? 1 : -1);
          setCurrentIndex(idx);
        }} className={`h-2 rounded-full transition-all duration-300 ${idx === currentIndex ? 'bg-white w-6' : 'bg-white/50 hover:bg-white/80 w-2'}`} aria-label={`Ir a la imagen ${idx + 1}`} data-id="element-35" data-mp="13ntmbanqaq8y" data-mpi={idx} />)}
        </div>
      </div>

      {/* Lightbox */}
      <AnimatePresence data-id="element-36" data-mp="21cwou8vvr79r">
        {lightbox !== null && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-[60] bg-navy/95 flex items-center justify-center p-4" onClick={() => setLightbox(null)} data-id="element-37" data-mp="1wdsgtlkozfl0">
            <button onClick={() => setLightbox(null)} className="absolute top-6 right-6 w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors" aria-label="Cerrar" data-id="element-38" data-mp="2dpqvfry5nvwy">
              <X className="w-6 h-6" data-id="element-39" data-mp="28v37bu72d3iw" />
            </button>
            <motion.img key={lightbox} initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.3
        }} src={photos[lightbox].src} alt={photos[lightbox].alt} className="max-w-full max-h-[85vh] object-contain rounded-xl shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-40" data-mp="1uwwtbylmrya5" />
          </motion.div>}
      </AnimatePresence>
    </SectionReveal>;
}